var o=function(){return document.documentElement.scrollTop||window.pageYOffset||document.body.scrollTop||0};export{o as default};
//# sourceMappingURL=scrollTop.mjs.map
